import type { RibbonId } from "owa-ribbon-ids";
import { type MailRibbonGroup, defaultConfig } from "owa-mail-ribbon-store-shared-types";

/**
 * Returns a set of valid config Ids from a specific tab layout. Useful to be called for different tabs.
 * @param layout `TabScalingAndLayoutConfig['layout']`, should be from defaultConfig
 */
function getValidDefaultConfigIds(layout: MailRibbonGroup[]): Set<RibbonId> {
    const validIds: Set<RibbonId> = new Set();
    
    for (const { controlIds, groupId } of layout) {
        validIds.add(groupId);
        
        for (const controlId of controlIds) {
            validIds.add(controlId);
        }
    }
    
    return validIds;
}

const homeTabValidDefaultConfigIdsCache = new Map<boolean, Set<RibbonId>>();
const viewTabValidDefaultConfigIdsCache = new Map<boolean, Set<RibbonId>>();

export function homeTabValidDefaultConfigIds(isSingleLineRibbon: boolean = true): Set<RibbonId> {
    const cachedValidIds = homeTabValidDefaultConfigIdsCache.get(isSingleLineRibbon);
    if (cachedValidIds) {
        return cachedValidIds;
    }
    
    const tab = isSingleLineRibbon
        ? defaultConfig.singleline.homeTab
        : defaultConfig.multiline.homeTab;
    const validIds = getValidDefaultConfigIds(tab.layout);
    homeTabValidDefaultConfigIdsCache.set(isSingleLineRibbon, validIds);
    return validIds;
}

export function viewTabValidDefaultConfigIds(isSingleLineRibbon: boolean = true): Set<RibbonId> {
    const cachedValidIds = viewTabValidDefaultConfigIdsCache.get(isSingleLineRibbon);
    if (cachedValidIds) {
        return cachedValidIds;
    }
    
    const tab = isSingleLineRibbon
        ? defaultConfig.singleline.viewTab
        : defaultConfig.multiline.viewTab;
    const validIds = getValidDefaultConfigIds(tab.layout);
    viewTabValidDefaultConfigIdsCache.set(isSingleLineRibbon, validIds);
    return validIds;
}
